import React from 'react';

const ImageIcon = ({ width = '16', height = '16', className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      width={width}
      height={height}
      {...rest}
    >
      <path
        d="M8 10.9609V13.3313"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.36328 5.35137L9.91024 5.125"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.91024 3.76603L9.36328 3.53906"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8754 2.80146L10.6484 2.25391"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8754 6.08594L10.6484 6.6329"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2344 2.80146L12.4613 2.25391"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.4607 6.63349L12.2344 6.08594"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.1992 3.76603L13.7468 3.53906"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.1992 5.125L13.7468 5.35196"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.9261 8.59389V9.77908C13.9261 10.0934 13.8012 10.3949 13.5789 10.6171C13.3567 10.8394 13.0552 10.9643 12.7409 10.9643H3.2594C2.94507 10.9643 2.64362 10.8394 2.42135 10.6171C2.19909 10.3949 2.07422 10.0934 2.07422 9.77908V3.85315C2.07422 3.53882 2.19909 3.23737 2.42135 3.0151C2.64362 2.79284 2.94507 2.66797 3.2594 2.66797H7.40755"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.62891 13.332H10.3696"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5551 6.22352C12.537 6.22352 13.3329 5.42759 13.3329 4.44575C13.3329 3.46391 12.537 2.66797 11.5551 2.66797C10.5733 2.66797 9.77734 3.46391 9.77734 4.44575C9.77734 5.42759 10.5733 6.22352 11.5551 6.22352Z"
        stroke="#6E7781"
        stroke-width="1.30719"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ImageIcon;
